import { useState, useEffect } from 'react';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(null);
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [countdown, setCountdown] = useState({ hours: 23, minutes: 59, seconds: 54 });

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev.seconds > 0) {
          return { ...prev, seconds: prev.seconds - 1 };
        } else if (prev.minutes > 0) {
          return { ...prev, minutes: prev.minutes - 1, seconds: 59 };
        } else if (prev.hours > 0) {
          return { hours: prev.hours - 1, minutes: 59, seconds: 59 };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const testimonials = [
    {
      name: 'María García',
      role: 'Emprendedora',
      text: '"Gracias a BudgetTrack ahorré S/2,400 en 6 meses y finalmente pude dar la cuota inicial de mi casa" - María G., Lima"',
      image: 'https://static.readdy.ai/image/3e793795e87845ada69b8088167d8f30/7c20902a9e930098296e3e917388d5ed.jpeg'
    },
    {
      name: 'Carlos Mendoza',
      role: 'Freelancer',
      text: '"Como freelancer, necesitaba algo simple pero potente. BudgetTrack es exactamente eso. La gestión de inventario y las métricas avanzadas me han ahorrado horas de trabajo cada semana."',
      image: 'https://static.readdy.ai/image/3e793795e87845ada69b8088167d8f30/99ff2300a707fc486248e3bc2fa97731.jpeg'
    },
    {
      name: 'Ana Lucía Torres',
      role: 'Dueña de tienda',
      text: '"Lo mejor que he invertido. Antes usaba Excel y perdía mucho tiempo. Ahora todo está automatizado y puedo ver mis finanzas desde el celular en cualquier momento."',
      image: 'https://static.readdy.ai/image/3e793795e87845ada69b8088167d8f30/94eea1df8e98333c4ab88ea8713e48cb.jpeg'
    },
    {
      name: 'Roberto Sánchez',
      role: 'Consultor financiero',
      text: '"Recomiendo BudgetTrack a todos mis clientes. Es intuitivo, completo y el precio es increíble. El soporte técnico también es excelente, siempre responden rápido."',
      image: 'https://readdy.ai/api/search-image?query=professional%20middle%20aged%20man%20portrait%20headshot%20with%20warm%20smile%20wearing%20business%20casual%20attire%20soft%20natural%20lighting%20clean%20white%20background%20high%20quality%20photography%20trustworthy%20expression&width=200&height=200&seq=avatar-004&orientation=squarish'
    },
    {
      name: 'Patricia Flores',
      role: 'Contadora',
      text: '"Los presupuestos personalizados y el historial de transacciones son funciones que uso todos los días. BudgetTrack ha simplificado mi trabajo enormemente."',
      image: 'https://readdy.ai/api/search-image?query=professional%20woman%20portrait%20headshot%20with%20confident%20smile%20wearing%20professional%20attire%20soft%20natural%20lighting%20clean%20white%20background%20high%20quality%20photography%20competent%20friendly%20expression&width=200&height=200&seq=avatar-005&orientation=squarish'
    },
    {
      name: 'Diego Ramírez',
      role: 'Pequeño empresario',
      text: '"Empecé a usar BudgetTrack hace 6 meses y mis finanzas nunca han estado mejor organizadas. El respaldo automático me da tranquilidad total."',
      image: 'https://readdy.ai/api/search-image?query=professional%20young%20latino%20man%20portrait%20headshot%20with%20enthusiastic%20smile%20wearing%20casual%20business%20shirt%20soft%20natural%20lighting%20clean%20white%20background%20high%20quality%20photography%20energetic%20expression&width=200&height=200&seq=avatar-006&orientation=squarish'
    }
  ];

  const faqs = [
    {
      question: '¿Cómo funciona BudgetTrack?',
      answer: 'BudgetTrack es una plataforma web intuitiva donde registras tus ingresos, gastos e inventario. El sistema genera automáticamente gráficos, métricas y reportes para que puedas visualizar tu situación financiera en tiempo real.'
    },
    {
      question: '¿Qué incluye el precio de $12 pago único?',
      answer: 'Incluye acceso completo y de por vida a todas las funcionalidades: gestión de gastos e ingresos, inventario, reportes, gráficos, metas de ahorro, transacciones recurrentes, respaldo en la nube, actualizaciones gratuitas y soporte técnico.'
    },
    {
      question: '¿Puedo descargar los reportes?',
      answer: 'Sí, puedes exportar todos tus reportes en formato PDF o Excel. Incluyen análisis detallados por categoría, período y tipo de transacción.'
    },
    {
      question: '¿Puedo acceder desde mi celular?',
      answer: 'Sí, BudgetTrack es 100% responsive. Puedes acceder desde cualquier dispositivo: celular, tablet o computadora, con la misma experiencia completa.'
    },
    {
      question: '¿Mis datos están seguros?',
      answer: 'Absolutamente. Utilizamos encriptación de nivel bancario para proteger tu información. Tus datos están respaldados automáticamente en la nube con los más altos estándares de seguridad.'
    },
    {
      question: '¿Cómo realizo el pago?',
      answer: 'El pago se procesa de forma segura a través de Hotmart, una plataforma internacional confiable. Puedes pagar con tarjeta de crédito, débito o PayPal.'
    },
    {
      question: '¿Qué pasa si necesito ayuda?',
      answer: 'Contamos con soporte técnico prioritario disponible 24/7. Puedes contactarnos por email, chat o WhatsApp y te responderemos lo antes posible.'
    },
    {
      question: '¿Es realmente un pago único?',
      answer: 'Sí, pagas una sola vez $12 y tienes acceso de por vida. Sin suscripciones mensuales, sin cargos ocultos, sin sorpresas.'
    },
    {
      question: '¿Sirve para negocios o solo uso personal?',
      answer: 'BudgetTrack funciona perfectamente para ambos. Puedes gestionar tus finanzas personales, tu negocio o ambos en la misma cuenta con categorías personalizadas.'
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-lg shadow-sm' : 'bg-transparent'}`}>
        <div className="container mx-auto max-w-6xl px-4">
          <div className="flex items-center justify-between h-16 sm:h-18 md:h-20">
            <a href="#" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
              <div className="w-8 h-8 sm:w-9 sm:h-9 rounded-lg gradient-hero flex items-center justify-center shadow-md">
                <span className="text-primary-foreground font-bold text-lg sm:text-xl">B</span>
              </div>
              <span className="font-bold text-lg sm:text-xl md:text-2xl">BudgetTrack</span>
            </a>

            <nav className="hidden md:flex items-center gap-6 lg:gap-8">
              <a href="#beneficios" className="text-muted-foreground hover:text-foreground transition-colors font-medium text-sm lg:text-base relative after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-primary after:transition-all hover:after:w-full">Beneficios</a>
              <a href="#funcionalidades" className="text-muted-foreground hover:text-foreground transition-colors font-medium text-sm lg:text-base relative after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-primary after:transition-all hover:after:w-full">Funcionalidades</a>
              <a href="#precio" className="text-muted-foreground hover:text-foreground transition-colors font-medium text-sm lg:text-base relative after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-primary after:transition-all hover:after:w-full">Precio</a>
              <a href="#faq" className="text-muted-foreground hover:text-foreground transition-colors font-medium text-sm lg:text-base relative after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-primary after:transition-all hover:after:w-full">FAQ</a>
            </nav>

            <button 
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden p-2 hover:bg-accent rounded-lg transition-all duration-300 cursor-pointer active:scale-95" 
              aria-label="Toggle menu"
            >
              <i className={`text-2xl transition-transform duration-300 ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </header>

      <main>
        {/* Hero Section */}
        <section className="relative min-h-screen flex items-center justify-center overflow-hidden px-4 sm:px-6 py-24 pt-28 sm:py-20 sm:pt-24 bg-white">
          {/* Textura decorativa visible - fondo blanco con patrones oscuros */}
          <div className="absolute inset-0 -z-10 pointer-events-none overflow-hidden">
            {/* Grid de puntos oscuros */}
            <div className="absolute inset-0" style={{
              backgroundImage: `radial-gradient(circle, rgba(13,148,136,0.18) 1.5px, transparent 1.5px)`,
              backgroundSize: '32px 32px'
            }}></div>
            {/* Líneas diagonales sutiles */}
            <div className="absolute inset-0" style={{
              backgroundImage: `repeating-linear-gradient(45deg, rgba(0,0,0,0.04) 0px, rgba(0,0,0,0.04) 1px, transparent 1px, transparent 28px)`,
            }}></div>
            {/* Círculos decorativos grandes */}
            <div className="absolute top-[-80px] left-[-80px] w-[420px] h-[420px] rounded-full border-[2px] border-teal-200/60"></div>
            <div className="absolute top-[-40px] left-[-40px] w-[280px] h-[280px] rounded-full border-[1.5px] border-teal-300/40"></div>
            <div className="absolute bottom-[-100px] right-[-100px] w-[500px] h-[500px] rounded-full border-[2px] border-teal-200/50"></div>
            <div className="absolute bottom-[-50px] right-[-50px] w-[320px] h-[320px] rounded-full border-[1.5px] border-teal-300/40"></div>
            {/* Manchas de color teal muy suaves */}
            <div className="absolute top-16 left-1/4 w-72 h-72 bg-teal-100/50 rounded-full blur-3xl"></div>
            <div className="absolute bottom-24 right-1/4 w-96 h-96 bg-teal-50/60 rounded-full blur-3xl"></div>
            {/* Líneas horizontales decorativas */}
            <div className="absolute inset-0" style={{
              backgroundImage: `repeating-linear-gradient(0deg, rgba(13,148,136,0.05) 0px, rgba(13,148,136,0.05) 1px, transparent 1px, transparent 64px)`,
            }}></div>
          </div>

          <div className="container mx-auto max-w-6xl relative z-10">
            <div className="text-center">
              <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-white/95 backdrop-blur-sm border-2 border-amber-500 text-amber-900 text-sm font-semibold mb-6 animate-[slideDown_0.8s_ease-out] shadow-lg">
                <i className="ri-question-line text-base"></i>
                ¿No sabes dónde se fue tu dinero este mes?
              </div>

              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-black mb-4 sm:mb-5 px-2 animate-[fadeInUp_1s_ease-out] leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
                Tu dinero bajo control con BudgetTrack
              </h1>

              <p className="text-base sm:text-lg md:text-xl text-foreground mb-6 sm:mb-8 px-2 max-w-3xl mx-auto animate-[fadeInUp_1.2s_ease-out] leading-relaxed">
                Gestiona ingresos, gastos e inventario en un solo lugar. Métricas inteligentes que te ayudan a tomar mejores decisiones financieras.
              </p>

              <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 w-full px-2 sm:px-0 animate-[fadeInUp_1.4s_ease-out]">
                <a href="#precio" className="group inline-flex items-center justify-center gap-3 whitespace-nowrap font-bold ring-offset-background transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-amber-600 hover:bg-amber-700 h-14 sm:h-16 w-full sm:w-auto px-8 sm:px-12 py-4 text-lg sm:text-xl rounded-xl cursor-pointer hover:scale-105 shadow-2xl hover:shadow-amber-500/50 text-white">
                  <span>Organiza tu dinero en 5 minutos</span>
                  <i className="ri-arrow-right-line text-2xl group-hover:translate-x-1 transition-transform"></i>
                </a>
              </div>

              <div className="mt-12 sm:mt-16 grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-6 max-w-3xl mx-auto px-2 sm:px-0">
                <div className="text-center p-4 sm:p-5 bg-card/50 backdrop-blur-sm rounded-xl border border-border/50 hover:border-primary/30 transition-all duration-300 hover:scale-105 animate-[fadeInUp_1.6s_ease-out]">
                  <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-gradient mb-1">500+</div>
                  <div className="text-xs sm:text-sm text-muted-foreground">Usuarios activos</div>
                </div>
                <div className="text-center p-4 sm:p-5 bg-card/50 backdrop-blur-sm rounded-xl border border-border/50 hover:border-primary/30 transition-all duration-300 hover:scale-105 animate-[fadeInUp_1.7s_ease-out]">
                  <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-gradient mb-1">$12</div>
                  <div className="text-xs sm:text-sm text-muted-foreground">Pago único</div>
                </div>
                <div className="text-center p-4 sm:p-5 bg-card/50 backdrop-blur-sm rounded-xl border border-border/50 hover:border-primary/30 transition-all duration-300 hover:scale-105 animate-[fadeInUp_1.8s_ease-out]">
                  <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-gradient mb-1">100%</div>
                  <div className="text-xs sm:text-sm text-muted-foreground">Seguro</div>
                </div>
                <div className="text-center p-4 sm:p-5 bg-card/50 backdrop-blur-sm rounded-xl border border-border/50 hover:border-primary/30 transition-all duration-300 hover:scale-105 animate-[fadeInUp_1.9s_ease-out]">
                  <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-gradient mb-1">24/7</div>
                  <div className="text-xs sm:text-sm text-muted-foreground">Disponible</div>
                </div>
              </div>

              <div className="mt-12 sm:mt-20 -mx-4 sm:mx-0 px-0 sm:px-0 animate-[fadeInUp_2s_ease-out]">
                <div className="relative w-full max-w-5xl mx-auto">
                  <div className="absolute -inset-2 sm:-inset-4 bg-primary/20 rounded-2xl sm:rounded-3xl blur-2xl animate-[pulse_3s_ease-in-out_infinite]"></div>
                  <div className="relative bg-card border-2 border-primary/30 rounded-xl sm:rounded-3xl p-3 sm:p-6 shadow-glow hover:scale-[1.02] transition-transform duration-500">
                    <div className="flex items-center justify-between gap-2 sm:gap-3 mb-3 sm:mb-6 px-1">
                      <div className="flex items-center gap-2 sm:gap-3">
                        <div className="w-10 h-10 sm:w-14 sm:h-14 rounded-full gradient-hero flex items-center justify-center flex-shrink-0 shadow-lg animate-[bounce_2s_ease-in-out_infinite]">
                          <i className="ri-play-fill text-white text-2xl sm:text-3xl"></i>
                        </div>
                        <div className="text-left">
                          <h3 className="text-sm sm:text-xl font-bold text-foreground">Ver Video</h3>
                          <p className="text-[10px] sm:text-sm text-muted-foreground leading-tight">Descubre todos los detalles de nuestro aplicativo</p>
                        </div>
                      </div>
                      <button className="flex items-center justify-center gap-1.5 sm:gap-2 px-3 py-2 sm:px-6 sm:py-3 rounded-full gradient-hero text-primary-foreground font-bold text-xs sm:text-base shadow-glow hover:scale-110 transition-all duration-300 border-2 border-white/30 cursor-pointer min-w-[80px] sm:min-w-[140px]">
                        <span className="text-base sm:text-xl">🔇</span>
                        <span className="hidden xs:inline text-xs sm:text-base">Activar</span>
                        <span className="xs:hidden text-xs">Sonido</span>
                      </button>
                    </div>
                    <div className="relative rounded-lg sm:rounded-2xl overflow-hidden bg-muted aspect-video w-full">
                      <iframe 
                        src="https://player.vimeo.com/video/1159768753?badge=0&autopause=0&player_id=0&app_id=58479&autoplay=1&loop=1&muted=1" 
                        className="absolute inset-0 w-full h-full" 
                        frameBorder="0" 
                        allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" 
                        title="BudgetTrack - Video Demo" 
                        allowFullScreen
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Benefits Section */}
        <section id="beneficios" className="relative py-16 sm:py-24 px-4 sm:px-6 overflow-hidden white-texture">
          <div className="container mx-auto max-w-6xl relative z-10">
            <div className="text-center mb-10 sm:mb-16 animate-in fade-in slide-in-from-bottom-4 duration-700">
              <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 sm:mb-4 px-2">
                Di adiós al estrés financiero. <span className="text-gradient">Todo tu dinero organizado en minutos</span>
              </h2>
              <p className="text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto px-2">
                Resultados reales que transforman tu relación con el dinero
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 sm:gap-6">
              {[
                {
                  icon: 'ri-money-dollar-circle-line',
                  title: 'Descubre los "gastos hormiga" que te roban dinero',
                  description: 'Identifica en segundos dónde se escapa tu dinero. Un café aquí, un taxi allá... Te mostramos la verdad completa de tus gastos diarios.'
                },
                {
                  icon: 'ri-line-chart-line',
                  title: 'Multiplica tus ingresos sin trabajar más horas',
                  description: 'Visualiza patrones ocultos en tus fuentes de ingreso y descubre oportunidades que estaban frente a ti todo el tiempo.'
                },
                {
                  icon: 'ri-archive-line',
                  title: 'Evita perder ventas por quedarte sin inventario',
                  description: 'Recibe alertas inteligentes antes de que se agote tu producto estrella. Nunca más pierdas dinero por falta de stock.'
                },
                {
                  icon: 'ri-bar-chart-box-line',
                  title: 'Entiende tu negocio en 3 segundos, no en 3 horas',
                  description: 'Gráficos tan claros que tu situación financiera salta a la vista. Toma decisiones con confianza, no con dudas.'
                },
                {
                  icon: 'ri-wallet-3-line',
                  title: 'Ahorra sin sentir que te estás sacrificando',
                  description: 'Alertas inteligentes te avisan antes de gastar de más. Alcanza tus metas financieras sin renunciar a lo que amas.'
                },
                {
                  icon: 'ri-shield-check-line',
                  title: 'Protección bancaria para tus datos más sensibles',
                  description: 'Encriptación de nivel militar. Tus números están más seguros aquí que en una bóveda física.'
                },
                {
                  icon: 'ri-history-line',
                  title: 'Aprende de tus errores sin repetirlos',
                  description: 'Revive cualquier momento de tu historia financiera. Descubre qué funcionó y qué no para mejorar cada mes.'
                },
                {
                  icon: 'ri-device-line',
                  title: 'Tu contador personal en el bolsillo 24/7',
                  description: 'Desde el sofá, la oficina o la playa. Gestiona todo desde tu celular sin depender de nadie.'
                },
                {
                  icon: 'ri-settings-3-line',
                  title: 'Categorías que reflejan TU vida, no plantillas genéricas',
                  description: 'Personaliza cada detalle según tu realidad. Porque tu negocio es único y merece un sistema único.'
                },
                {
                  icon: 'ri-file-download-line',
                  title: 'Reportes profesionales que impresionan en segundos',
                  description: 'Genera documentos detallados para tu contador, socio o banco. Luce profesional sin contratar a nadie.'
                }
              ].map((benefit, index) => (
                <div key={index} className="group p-5 sm:p-6 rounded-xl sm:rounded-2xl bg-white shadow-card hover:shadow-glow transition-all duration-300 border border-gray-100 hover:border-primary/30 hover:-translate-y-2 cursor-pointer animate-in fade-in slide-in-from-bottom-8 duration-700">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl sm:rounded-2xl gradient-hero flex items-center justify-center mb-4 sm:mb-5 group-hover:scale-110 group-hover:rotate-6 transition-all duration-300 shadow-lg">
                    <i className={`${benefit.icon} text-white text-2xl sm:text-3xl`}></i>
                  </div>
                  <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-2 group-hover:text-primary transition-colors">
                    {benefit.title}
                  </h3>
                  <p className="text-muted-foreground text-sm sm:text-sm leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Comparison Section */}
        <section id="comparacion" className="relative py-16 sm:py-24 px-4 sm:px-6 overflow-hidden white-texture-dots">
          <div className="container mx-auto max-w-7xl relative z-10">
            <div className="text-center mb-10 sm:mb-16 animate-in fade-in slide-in-from-bottom-4 duration-700">
              <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-medium mb-4">Comparación</span>
              <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 sm:mb-4 px-2">
                ¿Por qué elegir <span className="text-gradient">BudgetTrack</span>?
              </h2>
              <p className="text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto px-2">
                Compara y descubre por qué miles de personas ya dejaron atrás los métodos tradicionales
              </p>
            </div>

            {/* Desktop Comparison Table */}
            <div className="hidden lg:block overflow-hidden rounded-2xl border border-gray-100 shadow-2xl animate-in fade-in slide-in-from-bottom-8 duration-700 bg-white">
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead>
                    <tr className="bg-muted/30">
                      <th className="text-left p-6 font-semibold text-base w-2/5">Características</th>
                      <th className="p-6 text-center bg-primary/5 border-l border-border/30">
                        <div className="flex flex-col items-center gap-3">
                          <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-primary to-primary/70 flex items-center justify-center shadow-lg">
                            <i className="ri-smartphone-line text-white text-2xl"></i>
                          </div>
                          <div>
                            <div className="font-bold text-lg">BudgetTrack</div>
                            <span className="inline-block mt-2 px-3 py-1 rounded-full text-xs font-semibold bg-primary text-white">Recomendado</span>
                          </div>
                        </div>
                      </th>
                      <th className="p-6 text-center bg-green-50 border-l border-border/30">
                        <div className="flex flex-col items-center gap-3">
                          <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-green-600 to-green-500 flex items-center justify-center shadow-lg">
                            <i className="ri-file-excel-2-line text-white text-2xl"></i>
                          </div>
                          <div>
                            <div className="font-bold text-lg">Excel</div>
                          </div>
                        </div>
                      </th>
                      <th className="p-6 text-center bg-gray-50 border-l border-border/30">
                        <div className="flex flex-col items-center gap-3">
                          <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-gray-600 to-gray-500 flex items-center justify-center shadow-lg">
                            <i className="ri-book-2-line text-white text-2xl"></i>
                          </div>
                          <div>
                            <div className="font-bold text-lg">Cuaderno</div>
                          </div>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      { feature: 'Acceso desde cualquier dispositivo', budgettrack: true, excel: true, notebook: false },
                      { feature: 'Gráficos y visualizaciones automáticas', budgettrack: true, excel: true, notebook: false },
                      { feature: 'Alertas y recordatorios inteligentes', budgettrack: true, excel: false, notebook: false },
                      { feature: 'Categorización automática', budgettrack: true, excel: false, notebook: false },
                      { feature: 'Reportes profesionales en PDF', budgettrack: true, excel: true, notebook: false },
                      { feature: 'Metas de ahorro con seguimiento', budgettrack: true, excel: false, notebook: false },
                      { feature: 'Transacciones recurrentes', budgettrack: true, excel: false, notebook: false },
                      { feature: 'Respaldo automático en la nube', budgettrack: true, excel: true, notebook: false },
                      { feature: 'Análisis de tendencias', budgettrack: true, excel: false, notebook: false },
                      { feature: 'Interfaz intuitiva y moderna', budgettrack: true, excel: false, notebook: false },
                      { feature: 'Actualizaciones en tiempo real', budgettrack: true, excel: false, notebook: false },
                      { feature: 'Seguridad bancaria', budgettrack: true, excel: false, notebook: false }
                    ].map((row, index) => (
                      <tr key={index} className={`border-t border-gray-100 hover:bg-gray-50/50 transition-colors ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50/30'}`}>
                        <td className="p-5 font-medium text-sm">{row.feature}</td>
                        <td className="p-5 text-center border-l border-border/30 bg-primary/5">
                          <i className={`text-2xl inline-block hover:scale-110 transition-transform ${row.budgettrack ? 'ri-checkbox-circle-fill text-green-500' : 'ri-close-circle-fill text-red-400'}`}></i>
                        </td>
                        <td className="p-5 text-center border-l border-border/30 bg-green-50">
                          <i className={`text-2xl inline-block hover:scale-110 transition-transform ${row.excel ? 'ri-checkbox-circle-fill text-green-500' : 'ri-close-circle-fill text-red-400'}`}></i>
                        </td>
                        <td className="p-5 text-center border-l border-border/30 bg-gray-50">
                          <i className={`text-2xl inline-block hover:scale-110 transition-transform ${row.notebook ? 'ri-checkbox-circle-fill text-green-500' : 'ri-close-circle-fill text-red-400'}`}></i>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Mobile Comparison Cards */}
            <div className="lg:hidden space-y-6">
              {/* BudgetTrack Card */}
              <div className="p-6 rounded-2xl border-2 border-primary/30 bg-primary/5 animate-in fade-in slide-in-from-bottom-8 duration-700">
                <div className="flex items-center justify-between mb-6">
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-primary to-primary/70 flex items-center justify-center shadow-lg">
                      <i className="ri-smartphone-line text-white text-2xl"></i>
                    </div>
                    <h3 className="text-xl font-bold">BudgetTrack</h3>
                  </div>
                  <span className="px-3 py-1 rounded-full text-xs font-semibold bg-primary text-white">Recomendado</span>
                </div>
                <div className="space-y-3">
                  {[
                    'Acceso desde cualquier dispositivo',
                    'Gráficos y visualizaciones automáticas',
                    'Alertas y recordatorios inteligentes',
                    'Categorización automática',
                    'Reportes profesionales en PDF',
                    'Metas de ahorro con seguimiento',
                    'Transacciones recurrentes',
                    'Respaldo automático en la nube',
                    'Análisis de tendencias',
                    'Interfaz intuitiva y moderna',
                    'Actualizaciones en tiempo real',
                    'Seguridad bancaria'
                  ].map((feature, index) => (
                    <div key={index} className="flex items-center justify-between py-2 border-b border-border/30 last:border-0">
                      <span className="text-sm text-muted-foreground flex-1">{feature}</span>
                      <div className="ml-4">
                        <i className="ri-checkbox-circle-fill text-green-500 text-xl"></i>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Excel Card */}
              <div className="p-6 rounded-2xl border-2 border-green-200 bg-green-50 animate-in fade-in slide-in-from-bottom-8 duration-700">
                <div className="flex items-center justify-between mb-6">
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-green-600 to-green-500 flex items-center justify-center shadow-lg">
                      <i className="ri-file-excel-2-line text-white text-2xl"></i>
                    </div>
                    <h3 className="text-xl font-bold">Excel</h3>
                  </div>
                </div>
                <div className="space-y-3">
                  {[
                    { text: 'Acceso desde cualquier dispositivo', checked: true },
                    { text: 'Gráficos y visualizaciones automáticas', checked: true },
                    { text: 'Alertas y recordatorios inteligentes', checked: false },
                    { text: 'Categorización automática', checked: false },
                    { text: 'Reportes profesionales en PDF', checked: true },
                    { text: 'Metas de ahorro con seguimiento', checked: false },
                    { text: 'Transacciones recurrentes', checked: false },
                    { text: 'Respaldo automático en la nube', checked: true },
                    { text: 'Análisis de tendencias', checked: false },
                    { text: 'Interfaz intuitiva y moderna', checked: false },
                    { text: 'Actualizaciones en tiempo real', checked: false },
                    { text: 'Seguridad bancaria', checked: false }
                  ].map((feature, index) => (
                    <div key={index} className="flex items-center justify-between py-2 border-b border-border/30 last:border-0">
                      <span className="text-sm text-muted-foreground flex-1">{feature.text}</span>
                      <div className="ml-4">
                        <i className={`text-xl ${feature.checked ? 'ri-checkbox-circle-fill text-green-500' : 'ri-close-circle-fill text-red-400'}`}></i>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Notebook Card */}
              <div className="p-6 rounded-2xl border-2 border-gray-200 bg-gray-50 animate-in fade-in slide-in-from-bottom-8 duration-700">
                <div className="flex items-center justify-between mb-6">
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-gray-600 to-gray-500 flex items-center justify-center shadow-lg">
                      <i className="ri-book-2-line text-white text-2xl"></i>
                    </div>
                    <h3 className="text-xl font-bold">Cuaderno</h3>
                  </div>
                </div>
                <div className="space-y-3">
                  {[
                    'Acceso desde cualquier dispositivo',
                    'Gráficos y visualizaciones automáticas',
                    'Alertas y recordatorios inteligentes',
                    'Categorización automática',
                    'Reportes profesionales en PDF',
                    'Metas de ahorro con seguimiento',
                    'Transacciones recurrentes',
                    'Respaldo automático en la nube',
                    'Análisis de tendencias',
                    'Interfaz intuitiva y moderna',
                    'Actualizaciones en tiempo real',
                    'Seguridad bancaria'
                  ].map((feature, index) => (
                    <div key={index} className="flex items-center justify-between py-2 border-b border-border/30 last:border-0">
                      <span className="text-sm text-muted-foreground flex-1">{feature}</span>
                      <div className="ml-4">
                        <i className="ri-close-circle-fill text-red-400 text-xl"></i>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="mt-12 sm:mt-16 text-center animate-in fade-in slide-in-from-bottom-8 duration-700">
              <div className="inline-flex flex-col sm:flex-row items-center gap-4 p-6 sm:p-8 rounded-2xl bg-white border border-gray-100 shadow-card">
                <div className="flex-1 text-center sm:text-left">
                  <h3 className="text-xl sm:text-2xl font-bold mb-2">¿Listo para el cambio?</h3>
                  <p className="text-muted-foreground text-sm sm:text-base">Únete a miles de usuarios que ya transformaron su forma de gestionar el dinero</p>
                </div>
                <a href="#precio" className="whitespace-nowrap px-8 py-3 rounded-xl bg-gradient-to-r from-primary to-primary/80 text-white font-semibold hover:shadow-glow hover:scale-105 transition-all duration-300 cursor-pointer">
                  Comenzar Ahora
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section id="funcionalidades" className="relative py-16 sm:py-24 px-4 sm:px-6 overflow-hidden white-texture-alt">
          <div className="container mx-auto max-w-7xl relative z-10">
            <div className="text-center mb-12 sm:mb-20 animate-in fade-in slide-in-from-bottom-4 duration-700">
              <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-medium mb-4">Conoce la App</span>
              <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 px-2">
                Descubre todo lo que puedes hacer con <span className="text-gradient">BudgetTrack</span>
              </h2>
              <p className="text-base sm:text-lg text-muted-foreground max-w-3xl mx-auto px-2">
                Una plataforma completa diseñada para que tengas el control total de tus finanzas personales o de negocio.
              </p>
            </div>

            <div className="space-y-16 sm:space-y-24">
              {/* Feature 1 - Dashboard */}
              <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-center animate-in fade-in slide-in-from-bottom-8 duration-700">
                <div className="flex-1 space-y-4 sm:space-y-6 text-center lg:text-left">
                  <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-primary to-primary/70 text-white text-sm font-medium shadow-lg hover:scale-105 transition-transform duration-300">
                    Dashboard Completo
                  </div>
                  <h3 className="text-xl sm:text-2xl md:text-3xl font-bold">Dashboard Completo</h3>
                  <p className="text-muted-foreground text-sm sm:text-base md:text-lg max-w-lg mx-auto lg:mx-0">
                    Visualiza tu balance, ingresos y gastos en tiempo real. Gráficos interactivos de resumen mensual y categorías de gastos.
                  </p>
                  <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3 max-w-md mx-auto lg:mx-0">
                    {['Balance en tiempo real', 'Gráficos de categorías', 'Resumen mensual', 'Indicador de ahorro'].map((item, index) => (
                      <li key={index} className="flex items-center gap-2 text-xs sm:text-sm group">
                        <span className="w-2 h-2 rounded-full bg-gradient-to-r from-primary to-primary/70 group-hover:scale-125 transition-transform"></span>
                        <span className="group-hover:translate-x-1 transition-transform">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="flex-1 w-full">
                  <div className="relative group cursor-pointer">
                    <div className="absolute -inset-2 sm:-inset-4 bg-gradient-to-r from-primary to-primary/70 rounded-2xl sm:rounded-3xl opacity-20 blur-xl group-hover:opacity-40 transition-all duration-300"></div>
                    <div className="relative overflow-hidden rounded-xl sm:rounded-2xl shadow-2xl border border-border/50 group-hover:border-primary/30 transition-all duration-300 group-hover:scale-[1.02]">
                      <img 
                        alt="BudgetTrack - Dashboard Completo" 
                        className="w-full h-auto" 
                        loading="lazy" 
                        src="https://app.budgettrack.site/assets/dashboard-DSRUjFus.png"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Feature 2 - Ingresos */}
              <div className="flex flex-col lg:flex-row-reverse gap-8 lg:gap-12 items-center animate-in fade-in slide-in-from-bottom-8 duration-700">
                <div className="flex-1 space-y-4 sm:space-y-6 text-center lg:text-left">
                  <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-green-500 to-green-400 text-white text-sm font-medium shadow-lg hover:scale-105 transition-transform duration-300">
                    Gestión de Ingresos
                  </div>
                  <h3 className="text-xl sm:text-2xl md:text-3xl font-bold">Gestión de Ingresos</h3>
                  <p className="text-muted-foreground text-sm sm:text-base md:text-lg max-w-lg mx-auto lg:mx-0">
                    Registra todas tus fuentes de ingreso con categorías personalizadas. Historial completo y totales mensuales.
                  </p>
                  <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3 max-w-md mx-auto lg:mx-0">
                    {['Múltiples categorías', 'Historial detallado', 'Totales automáticos', 'Edición rápida'].map((item, index) => (
                      <li key={index} className="flex items-center gap-2 text-xs sm:text-sm group">
                        <span className="w-2 h-2 rounded-full bg-gradient-to-r from-green-500 to-green-400 group-hover:scale-125 transition-transform"></span>
                        <span className="group-hover:translate-x-1 transition-transform">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="flex-1 w-full">
                  <div className="relative group cursor-pointer">
                    <div className="absolute -inset-2 sm:-inset-4 bg-gradient-to-r from-green-500 to-green-400 rounded-2xl sm:rounded-3xl opacity-20 blur-xl group-hover:opacity-40 transition-all duration-300"></div>
                    <div className="relative overflow-hidden rounded-xl sm:rounded-2xl shadow-2xl border border-border/50 group-hover:border-primary/30 transition-all duration-300 group-hover:scale-[1.02]">
                      <img 
                        alt="BudgetTrack - Gestión de Ingresos" 
                        className="w-full h-auto" 
                        loading="lazy" 
                        src="https://app.budgettrack.site/assets/ingresos-BquTqDx1.png"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Feature 3 - Gastos */}
              <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-center animate-in fade-in slide-in-from-bottom-8 duration-700">
                <div className="flex-1 space-y-4 sm:space-y-6 text-center lg:text-left">
                  <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-red-500 to-red-400 text-white text-sm font-medium shadow-lg hover:scale-105 transition-transform duration-300">
                    Control de Gastos
                  </div>
                  <h3 className="text-xl sm:text-2xl md:text-3xl font-bold">Control de Gastos</h3>
                  <p className="text-muted-foreground text-sm sm:text-base md:text-lg max-w-lg mx-auto lg:mx-0">
                    Monitorea cada gasto por categoría. Visualiza tus top categorías con barras de progreso y edita transacciones fácilmente.
                  </p>
                  <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3 max-w-md mx-auto lg:mx-0">
                    {['Categorías con íconos', 'Top gastos visual', 'Barras de progreso', 'Historial completo'].map((item, index) => (
                      <li key={index} className="flex items-center gap-2 text-xs sm:text-sm group">
                        <span className="w-2 h-2 rounded-full bg-gradient-to-r from-red-500 to-red-400 group-hover:scale-125 transition-transform"></span>
                        <span className="group-hover:translate-x-1 transition-transform">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="flex-1 w-full">
                  <div className="relative group cursor-pointer">
                    <div className="absolute -inset-2 sm:-inset-4 bg-gradient-to-r from-red-500 to-red-400 rounded-2xl sm:rounded-3xl opacity-20 blur-xl group-hover:opacity-40 transition-all duration-300"></div>
                    <div className="relative overflow-hidden rounded-xl sm:rounded-2xl shadow-2xl border border-border/50 group-hover:border-primary/30 transition-all duration-300 group-hover:scale-[1.02]">
                      <img 
                        alt="BudgetTrack - Control de Gastos" 
                        className="w-full h-auto" 
                        loading="lazy" 
                        src="https://app.budgettrack.site/assets/gastos-9BQ3fEU-.png"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Feature 4 - Personalización */}
              <div className="flex flex-col lg:flex-row-reverse gap-8 lg:gap-12 items-center animate-in fade-in slide-in-from-bottom-8 duration-700">
                <div className="flex-1 space-y-4 sm:space-y-6 text-center lg:text-left">
                  <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-indigo-500 to-indigo-400 text-white text-sm font-medium shadow-lg hover:scale-105 transition-transform duration-300">
                    Personalización de Datos
                  </div>
                  <h3 className="text-xl sm:text-2xl md:text-3xl font-bold">Personaliza tus Gastos e Ingresos</h3>
                  <p className="text-muted-foreground text-sm sm:text-base md:text-lg max-w-lg mx-auto lg:mx-0">
                    Crea categorías personalizadas para tus gastos e ingresos según tus necesidades. Organiza tu información de manera clara y obtén datos más precisos sobre tus finanzas.
                  </p>
                  <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3 max-w-md mx-auto lg:mx-0">
                    {['Categorías personalizadas', 'Etiquetas únicas', 'Datos más claros', 'Organización flexible'].map((item, index) => (
                      <li key={index} className="flex items-center gap-2 text-xs sm:text-sm group">
                        <span className="w-2 h-2 rounded-full bg-gradient-to-r from-indigo-500 to-indigo-400 group-hover:scale-125 transition-transform"></span>
                        <span className="group-hover:translate-x-1 transition-transform">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="flex-1 w-full">
                  <div className="relative group cursor-pointer">
                    <div className="absolute -inset-2 sm:-inset-4 bg-gradient-to-r from-indigo-500 to-indigo-400 rounded-2xl sm:rounded-3xl opacity-20 blur-xl group-hover:opacity-40 transition-all duration-300"></div>
                    <div className="relative overflow-hidden rounded-xl sm:rounded-2xl shadow-2xl border border-border/50 group-hover:border-primary/30 transition-all duration-300 group-hover:scale-[1.02]">
                      <img 
                        alt="BudgetTrack - Personalización de Gastos e Ingresos" 
                        className="w-full h-auto" 
                        loading="lazy" 
                        src="https://readdy.ai/api/search-image?query=modern%20financial%20app%20interface%20showing%20customizable%20expense%20and%20income%20categories%20with%20colorful%20icons%20tags%20and%20labels%20organized%20in%20clean%20grid%20layout%20user%20creating%20personalized%20budget%20categories%20on%20tablet%20screen%20with%20simple%20minimalist%20background%20highlighting%20data%20organization%20and%20clarity&width=800&height=600&seq=custom-categories-001&orientation=landscape"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Feature 5 - Metas */}
              <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-center animate-in fade-in slide-in-from-bottom-8 duration-700">
                <div className="flex-1 space-y-4 sm:space-y-6 text-center lg:text-left">
                  <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-blue-500 to-blue-400 text-white text-sm font-medium shadow-lg hover:scale-105 transition-transform duration-300">
                    Metas de Ahorro
                  </div>
                  <h3 className="text-xl sm:text-2xl md:text-3xl font-bold">Metas de Ahorro</h3>
                  <p className="text-muted-foreground text-sm sm:text-base md:text-lg max-w-lg mx-auto lg:mx-0">
                    Define objetivos financieros y haz seguimiento de tu progreso. Alcanza tus metas con indicadores visuales motivadores.
                  </p>
                  <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3 max-w-md mx-auto lg:mx-0">
                    {['Objetivos personalizados', 'Progreso en tiempo real', 'Múltiples metas', 'Agregar fondos fácil'].map((item, index) => (
                      <li key={index} className="flex items-center gap-2 text-xs sm:text-sm group">
                        <span className="w-2 h-2 rounded-full bg-gradient-to-r from-blue-500 to-blue-400 group-hover:scale-125 transition-transform"></span>
                        <span className="group-hover:translate-x-1 transition-transform">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="flex-1 w-full">
                  <div className="relative group cursor-pointer">
                    <div className="absolute -inset-2 sm:-inset-4 bg-gradient-to-r from-blue-500 to-blue-400 rounded-2xl sm:rounded-3xl opacity-20 blur-xl group-hover:opacity-40 transition-all duration-300"></div>
                    <div className="relative overflow-hidden rounded-xl sm:rounded-2xl shadow-2xl border border-border/50 group-hover:border-primary/30 transition-all duration-300 group-hover:scale-[1.02]">
                      <img 
                        alt="BudgetTrack - Metas de Ahorro" 
                        className="w-full h-auto" 
                        loading="lazy" 
                        src="https://app.budgettrack.site/assets/metas-D-28cJ-I.png"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Feature 6 - Recurrentes */}
              <div className="flex flex-col lg:flex-row-reverse gap-8 lg:gap-12 items-center animate-in fade-in slide-in-from-bottom-8 duration-700">
                <div className="flex-1 space-y-4 sm:space-y-6 text-center lg:text-left">
                  <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-purple-500 to-purple-400 text-white text-sm font-medium shadow-lg hover:scale-105 transition-transform duration-300">
                    Transacciones Recurrentes
                  </div>
                  <h3 className="text-xl sm:text-2xl md:text-3xl font-bold">Transacciones Recurrentes</h3>
                  <p className="text-muted-foreground text-sm sm:text-base md:text-lg max-w-lg mx-auto lg:mx-0">
                    Automatiza gastos e ingresos fijos. Recordatorios diarios y registro con un solo clic.
                  </p>
                  <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3 max-w-md mx-auto lg:mx-0">
                    {['Gastos automáticos', 'Recordatorios', 'Un clic para registrar', 'Resumen diario'].map((item, index) => (
                      <li key={index} className="flex items-center gap-2 text-xs sm:text-sm group">
                        <span className="w-2 h-2 rounded-full bg-gradient-to-r from-purple-500 to-purple-400 group-hover:scale-125 transition-transform"></span>
                        <span className="group-hover:translate-x-1 transition-transform">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="flex-1 w-full">
                  <div className="relative group cursor-pointer">
                    <div className="absolute -inset-2 sm:-inset-4 bg-gradient-to-r from-purple-500 to-purple-400 rounded-2xl sm:rounded-3xl opacity-20 blur-xl group-hover:opacity-40 transition-all duration-300"></div>
                    <div className="relative overflow-hidden rounded-xl sm:rounded-2xl shadow-2xl border border-border/50 group-hover:border-primary/30 transition-all duration-300 group-hover:scale-[1.02]">
                      <img 
                        alt="BudgetTrack - Transacciones Recurrentes" 
                        className="w-full h-auto" 
                        loading="lazy" 
                        src="https://app.budgettrack.site/assets/recurrentes-B9fKmUnd.png"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Feature 7 - Reportes */}
              <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-center animate-in fade-in slide-in-from-bottom-8 duration-700">
                <div className="flex-1 space-y-4 sm:space-y-6 text-center lg:text-left">
                  <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-orange-500 to-orange-400 text-white text-sm font-medium shadow-lg hover:scale-105 transition-transform duration-300">
                    Reportes Detallados
                  </div>
                  <h3 className="text-xl sm:text-2xl md:text-3xl font-bold">Reportes Detallados</h3>
                  <p className="text-muted-foreground text-sm sm:text-base md:text-lg max-w-lg mx-auto lg:mx-0">
                    Analiza tus finanzas con reportes mensuales. Exporta a PDF y visualiza ingresos vs gastos por categoría.
                  </p>
                  <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3 max-w-md mx-auto lg:mx-0">
                    {['Exportar a PDF', 'Análisis por categoría', 'Tasa de ahorro', 'Filtros por período'].map((item, index) => (
                      <li key={index} className="flex items-center gap-2 text-xs sm:text-sm group">
                        <span className="w-2 h-2 rounded-full bg-gradient-to-r from-orange-500 to-orange-400 group-hover:scale-125 transition-transform"></span>
                        <span className="group-hover:translate-x-1 transition-transform">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="flex-1 w-full">
                  <div className="relative group cursor-pointer">
                    <div className="absolute -inset-2 sm:-inset-4 bg-gradient-to-r from-orange-500 to-orange-400 rounded-2xl sm:rounded-3xl opacity-20 blur-xl group-hover:opacity-40 transition-all duration-300"></div>
                    <div className="relative overflow-hidden rounded-xl sm:rounded-2xl shadow-2xl border border-border/50 group-hover:border-primary/30 transition-all duration-300 group-hover:scale-[1.02]">
                      <img 
                        alt="BudgetTrack - Reportes Detallados" 
                        className="w-full h-auto" 
                        loading="lazy" 
                        src="https://app.budgettrack.site/assets/reportes-CEHbQJ2m.png"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Feature 8 - Configuración */}
              <div className="flex flex-col lg:flex-row-reverse gap-8 lg:gap-12 items-center animate-in fade-in slide-in-from-bottom-8 duration-700">
                <div className="flex-1 space-y-4 sm:space-y-6 text-center lg:text-left">
                  <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-teal-500 to-teal-400 text-white text-sm font-medium shadow-lg hover:scale-105 transition-transform duration-300">
                    Personalización Total
                  </div>
                  <h3 className="text-xl sm:text-2xl md:text-3xl font-bold">Personalización Total</h3>
                  <p className="text-muted-foreground text-sm sm:text-base md:text-lg max-w-lg mx-auto lg:mx-0">
                    Configura tu perfil, cambia el tema de colores y personaliza tu experiencia según tus preferencias.
                  </p>
                  <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3 max-w-md mx-auto lg:mx-0">
                    {['Foto de perfil', '5 temas de colores', 'Datos personales', 'Interfaz adaptable'].map((item, index) => (
                      <li key={index} className="flex items-center gap-2 text-xs sm:text-sm group">
                        <span className="w-2 h-2 rounded-full bg-gradient-to-r from-teal-500 to-teal-400 group-hover:scale-125 transition-transform"></span>
                        <span className="group-hover:translate-x-1 transition-transform">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="flex-1 w-full">
                  <div className="relative group cursor-pointer">
                    <div className="absolute -inset-2 sm:-inset-4 bg-gradient-to-r from-teal-500 to-teal-400 rounded-2xl sm:rounded-3xl opacity-20 blur-xl group-hover:opacity-40 transition-all duration-300"></div>
                    <div className="relative overflow-hidden rounded-xl sm:rounded-2xl shadow-2xl border border-border/50 group-hover:border-primary/30 transition-all duration-300 group-hover:scale-[1.02]">
                      <img 
                        alt="BudgetTrack - Personalización Total" 
                        className="w-full h-auto" 
                        loading="lazy" 
                        src="https://app.budgettrack.site/assets/configuracion-D7GMgzLz.png"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* AI Section */}
        <section id="ia" className="relative py-16 sm:py-24 px-4 sm:px-6 overflow-hidden white-texture-dots">
          <div className="container mx-auto max-w-6xl relative z-10">
            <div className="text-center mb-10 sm:mb-16 animate-in fade-in slide-in-from-bottom-4 duration-700">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 text-primary text-sm font-medium mb-4">
                <i className="ri-robot-line text-lg"></i>
                Potenciado con IA
              </div>
              <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 sm:mb-4 px-2">
                Inteligencia Artificial con <span className="text-gradient">BudgetTrack</span>
              </h2>
              <p className="text-base sm:text-lg text-muted-foreground max-w-3xl mx-auto px-2 leading-relaxed">
                Puedes pedirle a la inteligencia artificial de nuestro programa que te haga un <strong className="text-foreground">resumen de todos tus gastos</strong> de manera rápida y que te dé <strong className="text-foreground">consejos</strong> sobre en dónde estás gastando más o cuál es el ingreso menor que estás teniendo.
              </p>
            </div>

            <div className="flex flex-col lg:flex-row gap-6 lg:gap-10 items-center justify-center">
              {/* Left - App Screenshots */}
              <div className="flex-1 w-full max-w-lg relative">
                <div className="relative group">
                  <div className="absolute -inset-3 bg-gradient-to-r from-primary/20 to-teal-400/20 rounded-2xl blur-xl group-hover:opacity-60 opacity-30 transition-all duration-300"></div>
                  <div className="relative bg-white rounded-2xl p-4 shadow-2xl border border-gray-100 group-hover:border-primary/30 transition-all duration-300 group-hover:scale-[1.02]">
                    {/* Mock App UI - BudgetTrack screens */}
                    <div className="relative w-full h-[340px] sm:h-[400px] overflow-hidden rounded-xl bg-gray-50">
                      {/* Background phone mockup */}
                      <div className="absolute left-2 top-8 w-[55%] h-[85%] bg-white rounded-xl shadow-xl border border-gray-200 overflow-hidden">
                        <div className="bg-primary/10 px-3 py-2 flex items-center gap-2">
                          <div className="w-6 h-6 rounded-md gradient-hero flex items-center justify-center">
                            <span className="text-white text-xs font-bold">B</span>
                          </div>
                          <span className="text-xs font-semibold text-foreground">BudgetTrack</span>
                        </div>
                        <div className="p-3 space-y-2">
                          <div className="bg-primary/5 rounded-lg p-2">
                            <div className="text-[10px] text-muted-foreground mb-1">Balance Total</div>
                            <div className="text-sm font-bold text-foreground">S/ 4,250.00</div>
                          </div>
                          <div className="space-y-1.5">
                            <div className="flex items-center justify-between">
                              <div className="flex items-center gap-1.5">
                                <div className="w-4 h-4 rounded bg-green-100 flex items-center justify-center">
                                  <i className="ri-arrow-up-line text-green-600 text-[8px]"></i>
                                </div>
                                <span className="text-[10px]">Ingresos</span>
                              </div>
                              <span className="text-[10px] font-semibold text-green-600">S/ 6,100</span>
                            </div>
                            <div className="flex items-center justify-between">
                              <div className="flex items-center gap-1.5">
                                <div className="w-4 h-4 rounded bg-red-100 flex items-center justify-center">
                                  <i className="ri-arrow-down-line text-red-600 text-[8px]"></i>
                                </div>
                                <span className="text-[10px]">Gastos</span>
                              </div>
                              <span className="text-[10px] font-semibold text-red-600">S/ 1,850</span>
                            </div>
                          </div>
                          <div className="bg-amber-50 rounded-lg p-2 mt-2">
                            <div className="text-[10px] text-amber-700 font-medium">📊 Resumen IA</div>
                            <div className="text-[9px] text-amber-600 mt-1">Tu gasto principal es transporte (42%)</div>
                          </div>
                        </div>
                      </div>
                      {/* Foreground chat mockup */}
                      <div className="absolute right-1 top-4 w-[55%] h-[88%] bg-white rounded-xl shadow-2xl border border-gray-200 overflow-hidden z-10">
                        <div className="bg-white px-3 py-2 border-b border-gray-100 flex items-center gap-2">
                          <div className="w-6 h-6 rounded-full gradient-hero flex items-center justify-center">
                            <i className="ri-robot-line text-white text-xs"></i>
                          </div>
                          <div className="flex-1">
                            <span className="text-xs font-semibold text-foreground">IA de BudgetTrack</span>
                            <div className="text-[9px] text-muted-foreground">Tu asesor financiero personal</div>
                          </div>
                          <div className="flex items-center gap-1">
                            <div className="w-1.5 h-1.5 rounded-full bg-green-500"></div>
                            <span className="text-[9px] text-green-600">En línea</span>
                          </div>
                        </div>
                        <div className="p-2 space-y-2 overflow-hidden h-[calc(100%-70px)]">
                          {/* User message */}
                          <div className="flex justify-end">
                            <div className="bg-amber-500 text-white text-[9px] px-2.5 py-1.5 rounded-xl rounded-tr-md max-w-[85%]">
                              ¿Cuáles son mis principales fuentes de ingreso?
                            </div>
                          </div>
                          {/* AI response */}
                          <div className="flex justify-start">
                            <div className="bg-gray-100 text-foreground text-[9px] px-2.5 py-2 rounded-xl rounded-tl-md max-w-[90%] leading-relaxed">
                              <p className="font-medium mb-1">¡Hola! He analizado tus movimientos:</p>
                              <p className="mb-1">💰 <strong>Tus Fuentes de Ingreso</strong></p>
                              <p className="text-[8px] text-muted-foreground mb-1">Tus ingresos totales suman S/ 2,100.00</p>
                              <p className="text-[8px] mb-1">• Transporte (S/ 1,900): 90.5%</p>
                              <p className="text-[8px]">• Otros (S/ 100): Registrado como &quot;[skool]&quot;</p>
                              <p className="text-[8px] mb-1">• Negocio (S/ 100): Ingreso adicional</p>
                              <p className="text-[8px] mt-1">💡 <strong>Consejo:</strong> Tu economía depende del 90% de &quot;transporte&quot;. Te sugiero diversificar.</p>
                            </div>
                          </div>
                        </div>
                        {/* Input */}
                        <div className="absolute bottom-0 left-0 right-0 px-2 py-1.5 bg-white border-t border-gray-100">
                          <div className="flex items-center gap-1.5 bg-gray-50 rounded-full px-2.5 py-1.5">
                            <span className="text-[9px] text-muted-foreground flex-1">Pregunta sobre tus finanzas...</span>
                            <div className="w-5 h-5 rounded-full bg-primary flex items-center justify-center">
                              <i className="ri-send-plane-fill text-white text-[8px]"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* IA Active badge */}
                    <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20">
                      <div className="flex items-center gap-2 px-4 py-2 bg-white rounded-full shadow-lg border border-gray-100">
                        <div className="w-7 h-7 rounded-full gradient-hero flex items-center justify-center">
                          <i className="ri-robot-line text-white text-sm"></i>
                        </div>
                        <div>
                          <div className="text-xs font-bold text-foreground">IA Activa</div>
                          <div className="text-[10px] text-muted-foreground">Analizando tus finanzas</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right - Chat Preview */}
              <div className="flex-1 w-full max-w-lg relative">
                <div className="relative group">
                  <div className="absolute -inset-3 bg-gradient-to-r from-teal-400/20 to-primary/20 rounded-2xl blur-xl group-hover:opacity-60 opacity-30 transition-all duration-300"></div>
                  <div className="relative bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden group-hover:border-primary/30 transition-all duration-300 group-hover:scale-[1.02]">
                    {/* Chat Header */}
                    <div className="bg-white px-5 py-4 border-b border-gray-100 flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full gradient-hero flex items-center justify-center shadow-md">
                        <i className="ri-robot-line text-white text-lg"></i>
                      </div>
                      <div className="flex-1">
                        <h4 className="text-sm font-bold text-foreground">IA de BudgetTrack</h4>
                        <p className="text-xs text-muted-foreground">Tu asesor financiero personal</p>
                      </div>
                      <div className="flex items-center gap-1.5">
                        <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></div>
                        <span className="text-xs text-green-600 font-medium">En línea</span>
                      </div>
                    </div>
                    {/* Chat Messages */}
                    <div className="p-5 space-y-4 min-h-[320px] bg-gray-50/30">
                      {/* User message */}
                      <div className="flex justify-end">
                        <div className="bg-amber-500 text-white text-sm px-4 py-2.5 rounded-2xl rounded-tr-md max-w-[80%] shadow-sm">
                          ¿Cuáles son mis principales fuentes de ingreso?
                        </div>
                      </div>
                      {/* AI response */}
                      <div className="flex justify-start">
                        <div className="bg-white text-foreground text-sm px-4 py-3 rounded-2xl rounded-tl-md max-w-[90%] shadow-sm border border-gray-100 leading-relaxed">
                          <p className="font-medium mb-2">¡Hola! Soy tu asesor de BudgetTrack. He analizado tus movimientos:</p>
                          <p className="mb-2">💰 <strong>Tus Fuentes de Ingreso</strong></p>
                          <p className="text-muted-foreground text-xs mb-2">Tus ingresos totales suman S/ 2,100.00</p>
                          <div className="space-y-1 text-xs">
                            <p>• Transporte (S/ 1,900.00): 90.5% del total</p>
                            <p>• Otros (S/ 100.00): Registrado como &quot;[skool]&quot;</p>
                            <p>• Negocio (S/ 100.00): Ingreso adicional</p>
                          </div>
                          <div className="mt-3 pt-2 border-t border-gray-100">
                            <p className="text-xs">💡 <strong>Consejo:</strong> Tu economía depende del 90% de &quot;transporte&quot;. Te sugiero diversificar tus fuentes de ingreso.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Chat Input */}
                    <div className="px-5 py-3 bg-white border-t border-gray-100">
                      <div className="flex items-center gap-3 bg-gray-50 rounded-full px-4 py-2.5 border border-gray-200">
                        <span className="text-sm text-muted-foreground flex-1">Pregunta sobre tus finanzas...</span>
                        <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center cursor-pointer hover:scale-110 transition-transform shadow-md">
                          <i className="ri-send-plane-fill text-white text-sm"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* AI Boost Block */}
            <div className="mt-6 relative overflow-hidden rounded-2xl border border-teal-200 bg-gradient-to-br from-teal-50 via-white to-emerald-50 shadow-md">
              {/* Decorative dots */}
              <div className="absolute inset-0 pointer-events-none" style={{
                backgroundImage: `radial-gradient(circle, rgba(13,148,136,0.10) 1px, transparent 1px)`,
                backgroundSize: '20px 20px'
              }}></div>
              <div className="relative p-5">
                {/* Header */}
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-xl gradient-hero flex items-center justify-center shadow-md flex-shrink-0">
                    <i className="ri-robot-line text-white text-xl"></i>
                  </div>
                  <div className="text-left">
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-bold text-foreground">IA incluida en tu plan</span>
                      <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-primary text-white text-[10px] font-bold">
                        <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse inline-block"></span>
                        ACTIVA
                      </span>
                    </div>
                    <p className="text-xs text-muted-foreground">Tu asesor financiero inteligente 24/7</p>
                  </div>
                </div>

                {/* AI Features Grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
                  {[
                    { icon: 'ri-pie-chart-2-line', color: 'text-teal-600', bg: 'bg-teal-100', title: 'Resumen automático', desc: 'Análisis completo de todos tus gastos en segundos' },
                    { icon: 'ri-lightbulb-flash-line', color: 'text-amber-600', bg: 'bg-amber-100', title: 'Consejos personalizados', desc: 'Recomendaciones según tus hábitos financieros' },
                    { icon: 'ri-line-chart-line', color: 'text-emerald-600', bg: 'bg-emerald-100', title: 'Detecta patrones', desc: 'Identifica dónde gastas más y cómo optimizarlo' },
                    { icon: 'ri-chat-smile-3-line', color: 'text-rose-500', bg: 'bg-rose-100', title: 'Chat financiero', desc: 'Pregunta lo que quieras sobre tus finanzas' }
                  ].map((item, i) => (
                    <div key={i} className="flex items-start gap-2.5 p-3 rounded-xl bg-white/80 border border-gray-100 hover:border-primary/30 hover:shadow-sm transition-all duration-200 group">
                      <div className={`w-8 h-8 rounded-lg ${item.bg} flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform`}>
                        <i className={`${item.icon} ${item.color} text-base`}></i>
                      </div>
                      <div className="text-left">
                        <p className="text-xs font-semibold text-foreground">{item.title}</p>
                        <p className="text-[11px] text-muted-foreground leading-snug">{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Mini chat preview */}
                <div className="bg-white rounded-xl border border-gray-100 p-3 shadow-sm">
                  <div className="flex items-center gap-2 mb-2.5">
                    <div className="w-5 h-5 rounded-full gradient-hero flex items-center justify-center">
                      <i className="ri-robot-line text-white text-[10px]"></i>
                    </div>
                    <span className="text-[11px] font-semibold text-foreground">IA de BudgetTrack</span>
                    <div className="flex items-center gap-1 ml-auto">
                      <div className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse"></div>
                      <span className="text-[10px] text-green-600">En línea</span>
                    </div>
                  </div>
                  <div className="space-y-2">
                    <div className="flex justify-end">
                      <div className="bg-amber-500 text-white text-[10px] px-3 py-1.5 rounded-xl rounded-tr-sm max-w-[80%]">
                        ¿En qué estoy gastando más este mes?
                      </div>
                    </div>
                    <div className="flex justify-start">
                      <div className="bg-gray-50 text-foreground text-[10px] px-3 py-2 rounded-xl rounded-tl-sm max-w-[90%] border border-gray-100 leading-relaxed">
                        📊 Tu mayor gasto es <strong>Alimentación (38%)</strong>, seguido de Transporte (24%). Te recomiendo reducir comidas fuera de casa para ahorrar <strong>S/ 180 al mes</strong>. 💡
                      </div>
                    </div>
                  </div>
                </div>

                <p className="text-[11px] text-center text-muted-foreground mt-3 flex items-center justify-center gap-1.5">
                  <i className="ri-shield-check-line text-primary"></i>
                  Incluido sin costo adicional con tu acceso de por vida
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Pricing Section */}
        <section id="precio" className="relative py-16 sm:py-24 px-4 sm:px-6 overflow-hidden white-texture">
          <div className="container mx-auto max-w-4xl relative z-10">
            <div className="text-center mb-8 sm:mb-12 animate-in fade-in slide-in-from-bottom-4 duration-700">
              <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 sm:mb-4 px-2">
                Un precio, <span className="text-gradient">todo incluido</span>
              </h2>
              <p className="text-base sm:text-lg text-muted-foreground px-2">
                Sin sorpresas, sin costos ocultos. Acceso de por vida.
              </p>
            </div>

            {/* Bonus eBook */}
            <div className="relative mb-8 sm:mb-10 animate-in fade-in slide-in-from-bottom-6 duration-700">
              <div className="absolute inset-0 bg-gradient-to-r from-amber-500/10 via-orange-500/10 to-amber-500/10 rounded-2xl blur-xl"></div>
              <div className="relative bg-gradient-to-r from-amber-50 to-orange-50 rounded-2xl p-6 sm:p-8 border-2 border-amber-400/50 shadow-xl hover:shadow-2xl hover:scale-[1.02] transition-all duration-300">
                <div className="flex items-start gap-4 mb-4">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-xl bg-gradient-to-br from-amber-500 to-orange-600 flex items-center justify-center flex-shrink-0 shadow-lg group-hover:scale-110 transition-transform">
                    <i className="ri-gift-line text-white text-2xl sm:text-3xl"></i>
                  </div>
                  <div className="flex-1">
                    <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-500 text-white text-xs sm:text-sm font-bold mb-2 animate-pulse">
                      <i className="ri-time-line"></i>
                      BONO ESPECIAL SOLO POR HOY
                    </div>
                    <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-amber-900 dark:text-amber-100 mb-2">
                      🎁 eBook GRATIS en PDF
                    </h3>
                    <p className="text-base sm:text-lg text-amber-900 dark:text-amber-100 font-bold mb-2">
                      "De Caos Financiero a ControlTotal en 30 Días"
                    </p>
                    <p className="text-sm sm:text-base text-amber-800 dark:text-amber-200 mb-3">
                      Una guía práctica que te acompaña paso a paso para implementar el sistema, crear hábitos financieros y tomar el control real de tu dinero.
                    </p>
                    <div className="flex flex-wrap items-center gap-3 sm:gap-4">
                      <div className="flex items-center gap-2">
                        <span className="text-lg sm:text-xl font-bold text-amber-900 dark:text-amber-100 line-through opacity-60">$30</span>
                        <span className="text-2xl sm:text-3xl font-extrabold text-gradient">GRATIS</span>
                      </div>
                      <div className="flex items-center gap-2 text-amber-800 dark:text-amber-200 text-sm sm:text-base">
                        <i className="ri-file-pdf-line text-xl"></i>
                        <span className="font-semibold">Formato PDF descargable</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 pt-4 border-t border-amber-300/50">
                  {[
                    { icon: 'ri-roadmap-line', text: 'Guía paso a paso' },
                    { icon: 'ri-calendar-check-line', text: 'Plan de 30 días' },
                    { icon: 'ri-line-chart-line', text: 'Hábitos financieros' }
                  ].map((item, index) => (
                    <div key={index} className="flex items-center gap-2 text-amber-900 dark:text-amber-100 hover:translate-x-1 transition-transform">
                      <i className={`${item.icon} text-lg text-amber-600`}></i>
                      <span className="text-sm font-medium">{item.text}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Pricing Card */}
            <div className="relative animate-in fade-in slide-in-from-bottom-8 duration-700">
              <div className="absolute inset-0 gradient-hero rounded-3xl blur-xl opacity-10"></div>
              <div className="relative bg-white rounded-2xl sm:rounded-3xl p-5 sm:p-8 md:p-12 shadow-card border border-gray-100 hover:border-primary/30 hover:shadow-glow transition-all duration-300 hover:scale-[1.02]">
                <div className="flex flex-col items-center gap-6 sm:gap-8">
                  <div className="text-center w-full">
                    <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary/10 text-primary text-xs sm:text-sm font-medium mb-3 sm:mb-4">
                      <i className="ri-infinity-line text-base"></i>
                      Acceso de por vida
                    </div>
                    <div className="flex items-baseline gap-2 justify-center mb-2">
                      <span className="text-7xl sm:text-8xl md:text-9xl font-extrabold text-gradient drop-shadow-[0_0_30px_rgba(20,184,166,0.5)] animate-pulse">
                        $12
                      </span>
                    </div>
                    <p className="text-muted-foreground text-sm sm:text-base mt-2">
                      Pago único • Sin suscripciones
                    </p>
                  </div>

                  {/* Countdown Timer */}
                  <div className="text-center w-full max-w-md mx-auto">
                    <div className="p-4 sm:p-5 bg-gradient-to-r from-red-50 to-orange-50 dark:from-red-950/30 dark:to-orange-950/30 rounded-xl border-2 border-red-400/50">
                      <p className="text-sm font-semibold text-red-700 dark:text-red-300 mb-3 flex items-center justify-center gap-2">
                        <i className="ri-alarm-warning-line text-lg animate-pulse"></i>
                        Este precio solo estará disponible por tiempo limitado
                      </p>
                      <div className="flex items-center justify-center gap-3 mb-3">
                        <div className="flex flex-col items-center">
                          <div className="bg-gradient-to-br from-red-600 to-orange-600 text-white font-bold text-xl sm:text-2xl px-3 py-2 rounded-lg min-w-[50px] shadow-lg">
                            {countdown.hours.toString().padStart(2, '0')}
                          </div>
                          <span className="text-xs text-red-700 dark:text-red-300 mt-1 font-medium">Horas</span>
                        </div>
                        <span className="text-2xl font-bold text-red-600 dark:text-red-400">:</span>
                        <div className="flex flex-col items-center">
                          <div className="bg-gradient-to-br from-red-600 to-orange-600 text-white font-bold text-xl sm:text-2xl px-3 py-2 rounded-lg min-w-[50px] shadow-lg">
                            {countdown.minutes.toString().padStart(2, '0')}
                          </div>
                          <span className="text-xs text-red-700 dark:text-red-300 mt-1 font-medium">Minutos</span>
                        </div>
                        <span className="text-2xl font-bold text-red-600 dark:text-red-400">:</span>
                        <div className="flex flex-col items-center">
                          <div className="bg-gradient-to-br from-red-600 to-orange-600 text-white font-bold text-xl sm:text-2xl px-3 py-2 rounded-lg min-w-[50px] shadow-lg">
                            {countdown.seconds.toString().padStart(2, '0')}
                          </div>
                          <span className="text-xs text-red-700 dark:text-red-300 mt-1 font-medium">Segundos</span>
                        </div>
                      </div>
                      <p className="text-sm font-bold text-red-800 dark:text-red-200">
                        Próximo precio: <span className="text-lg">$25</span>
                      </p>
                    </div>

                    <a 
                      href="https://pay.hotmart.com/G104158314B?checkoutMode=10" 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="group inline-flex items-center justify-center gap-2 sm:gap-3 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-gradient-to-r from-orange-500 via-rose-500 to-pink-500 hover:from-orange-600 hover:via-rose-600 hover:to-pink-600 text-white shadow-[0_0_30px_rgba(249,115,22,0.5)] hover:shadow-[0_0_40px_rgba(249,115,22,0.7)] w-full px-6 sm:px-8 py-4 sm:py-5 text-base sm:text-lg font-bold rounded-xl hover:scale-105 transition-all duration-300 cursor-pointer animate-[pulse_2s_ease-in-out_infinite] mt-5 leading-tight"
                    >
                      <i className="ri-shopping-cart-line text-xl sm:text-2xl flex-shrink-0"></i>
                      <span className="text-center">Sí, quiero mi acceso de por vida por $12</span>
                      <i className="ri-arrow-right-line text-lg sm:text-xl group-hover:translate-x-1 transition-transform flex-shrink-0"></i>
                    </a>

                    <p className="text-xs sm:text-sm text-muted-foreground mt-4 flex items-center justify-center gap-2">
                      <i className="ri-flashlight-line text-primary"></i>
                      Acceso inmediato • Sin tarjeta requerida
                    </p>

                    {/* AI Boost Block */}
                    <div className="mt-6 relative overflow-hidden rounded-2xl border border-teal-200 bg-gradient-to-br from-teal-50 via-white to-emerald-50 shadow-md">
                      {/* Decorative dots */}
                      <div className="absolute inset-0 pointer-events-none" style={{
                        backgroundImage: `radial-gradient(circle, rgba(13,148,136,0.10) 1px, transparent 1px)`,
                        backgroundSize: '20px 20px'
                      }}></div>
                      <div className="relative p-5">
                        {/* Header */}
                        <div className="flex items-center gap-3 mb-4">
                          <div className="w-10 h-10 rounded-xl gradient-hero flex items-center justify-center shadow-md flex-shrink-0">
                            <i className="ri-robot-line text-white text-xl"></i>
                          </div>
                          <div className="text-left">
                            <div className="flex items-center gap-2">
                              <span className="text-sm font-bold text-foreground">IA incluida en tu plan</span>
                              <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-primary text-white text-[10px] font-bold">
                                <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse inline-block"></span>
                                ACTIVA
                              </span>
                            </div>
                            <p className="text-xs text-muted-foreground">Tu asesor financiero inteligente 24/7</p>
                          </div>
                        </div>

                        {/* AI Features Grid */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
                          {[
                            { icon: 'ri-pie-chart-2-line', color: 'text-teal-600', bg: 'bg-teal-100', title: 'Resumen automático', desc: 'Análisis completo de todos tus gastos en segundos' },
                            { icon: 'ri-lightbulb-flash-line', color: 'text-amber-600', bg: 'bg-amber-100', title: 'Consejos personalizados', desc: 'Recomendaciones según tus hábitos financieros' },
                            { icon: 'ri-line-chart-line', color: 'text-emerald-600', bg: 'bg-emerald-100', title: 'Detecta patrones', desc: 'Identifica dónde gastas más y cómo optimizarlo' },
                            { icon: 'ri-chat-smile-3-line', color: 'text-rose-500', bg: 'bg-rose-100', title: 'Chat financiero', desc: 'Pregunta lo que quieras sobre tus finanzas' }
                          ].map((item, i) => (
                            <div key={i} className="flex items-start gap-2.5 p-3 rounded-xl bg-white/80 border border-gray-100 hover:border-primary/30 hover:shadow-sm transition-all duration-200 group">
                              <div className={`w-8 h-8 rounded-lg ${item.bg} flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform`}>
                                <i className={`${item.icon} ${item.color} text-base`}></i>
                              </div>
                              <div className="text-left">
                                <p className="text-xs font-semibold text-foreground">{item.title}</p>
                                <p className="text-[11px] text-muted-foreground leading-snug">{item.desc}</p>
                              </div>
                            </div>
                          ))}
                        </div>

                        {/* Mini chat preview */}
                        <div className="bg-white rounded-xl border border-gray-100 p-3 shadow-sm">
                          <div className="flex items-center gap-2 mb-2.5">
                            <div className="w-5 h-5 rounded-full gradient-hero flex items-center justify-center">
                              <i className="ri-robot-line text-white text-[10px]"></i>
                            </div>
                            <span className="text-[11px] font-semibold text-foreground">IA de BudgetTrack</span>
                            <div className="flex items-center gap-1 ml-auto">
                              <div className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse"></div>
                              <span className="text-[10px] text-green-600">En línea</span>
                            </div>
                          </div>
                          <div className="space-y-2">
                            <div className="flex justify-end">
                              <div className="bg-amber-500 text-white text-[10px] px-3 py-1.5 rounded-xl rounded-tr-sm max-w-[80%]">
                                ¿En qué estoy gastando más este mes?
                              </div>
                            </div>
                            <div className="flex justify-start">
                              <div className="bg-gray-50 text-foreground text-[10px] px-3 py-2 rounded-xl rounded-tl-sm max-w-[90%] border border-gray-100 leading-relaxed">
                                📊 Tu mayor gasto es <strong>Alimentación (38%)</strong>, seguido de Transporte (24%). Te recomiendo reducir comidas fuera de casa para ahorrar <strong>S/ 180 al mes</strong>. 💡
                              </div>
                            </div>
                          </div>
                        </div>

                        <p className="text-[11px] text-center text-muted-foreground mt-3 flex items-center justify-center gap-1.5">
                          <i className="ri-shield-check-line text-primary"></i>
                          Incluido sin costo adicional con tu acceso de por vida
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Features List */}
                <div className="mt-6 sm:mt-12 pt-6 sm:pt-10 border-t border-gray-100">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                    {[
                      'Control completo de gastos e ingresos',
                      'Gestión de inventario ilimitada',
                      'Métricas y gráficos avanzados',
                      'Reportes mensuales y anuales',
                      'Presupuestos personalizados',
                      'Historial de transacciones',
                      'Acceso desde cualquier dispositivo',
                      'Soporte técnico prioritario',
                      'Actualizaciones gratuitas',
                      'Respaldo automático de datos',
                      'Acceso de por vida',
                      'Descarga reportes en PDF o Excel'
                    ].map((feature, index) => (
                      <div key={index} className="flex items-center gap-2 sm:gap-3 group hover:translate-x-1 transition-transform duration-200 animate-in fade-in slide-in-from-left-4 duration-500">
                        <div className="w-5 h-5 sm:w-6 sm:h-6 rounded-full gradient-hero flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                          <i className="ri-check-line text-white text-sm sm:text-base"></i>
                        </div>
                        <span className="text-foreground text-sm sm:text-base">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-8 sm:mt-12 text-center animate-in fade-in slide-in-from-bottom-4 duration-700">
              <p className="text-sm sm:text-base text-muted-foreground mb-4">¿Tienes dudas sobre el precio?</p>
              <a 
                href="#faq" 
                className="group inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium ring-offset-background transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-white hover:bg-gray-50 hover:text-accent-foreground px-6 sm:px-8 py-3 sm:py-3.5 text-sm sm:text-base rounded-xl border-2 border-gray-200 cursor-pointer hover:scale-105 hover:border-primary/50 hover:shadow-lg"
              >
                <i className="ri-question-line text-lg sm:text-xl"></i>
                <span>Ver Preguntas Frecuentes</span>
                <i className="ri-arrow-down-line text-base sm:text-lg group-hover:translate-y-1 transition-transform"></i>
              </a>
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section id="testimonios" className="py-16 sm:py-24 px-4 sm:px-6 white-texture-dots relative">
          <div className="container mx-auto max-w-6xl relative z-10">
            <div className="text-center mb-12 sm:mb-16 animate-in fade-in slide-in-from-bottom-4 duration-700">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 text-primary text-sm font-medium mb-4">
                <i className="ri-chat-quote-line text-lg"></i>
                Testimonios
              </div>
              <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
                Lo que dicen <span className="text-gradient">nuestros usuarios</span>
              </h2>
              <p className="text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto">
                Miles de personas ya confían en BudgetTrack para gestionar sus finanzas personales y de negocio.
              </p>
            </div>

            {/* Desktop Testimonials */}
            <div className="hidden md:block relative">
              <div className="grid grid-cols-3 gap-6">
                {testimonials.slice(0, 3).map((testimonial, index) => (
                  <div key={index} className="group bg-white rounded-2xl p-6 shadow-lg border border-border/50 hover:border-primary/30 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 animate-in fade-in slide-in-from-bottom-8 duration-700">
                    <div className="flex items-center gap-1 mb-4">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-amber-400 text-lg"></i>
                      ))}
                    </div>
                    <p className="text-foreground text-sm leading-relaxed mb-6">{testimonial.text}</p>
                    <div className="flex items-center gap-4 pt-4 border-t border-border/50">
                      <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 ring-2 ring-primary/20 group-hover:ring-primary/40 transition-all">
                        <img alt={testimonial.name} className="w-full h-full object-cover" src={testimonial.image} />
                      </div>
                      <div>
                        <h4 className="font-semibold text-foreground">{testimonial.name}</h4>
                        <p className="text-sm text-muted-foreground">{testimonial.role}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Mobile Testimonials Carousel */}
            <div className="md:hidden">
              <div className="relative overflow-hidden">
                <div className="flex transition-transform duration-500 ease-out" style={{ transform: `translateX(-${currentTestimonial * 100}%)` }}>
                  {testimonials.map((testimonial, index) => (
                    <div key={index} className="w-full flex-shrink-0 px-2">
                      <div className="bg-white rounded-2xl p-6 shadow-lg border border-border/50">
                        <div className="flex items-center gap-1 mb-4">
                          {[...Array(5)].map((_, i) => (
                            <i key={i} className="ri-star-fill text-amber-400 text-lg"></i>
                          ))}
                        </div>
                        <p className="text-foreground text-sm leading-relaxed mb-6">{testimonial.text}</p>
                        <div className="flex items-center gap-4 pt-4 border-t border-border/50">
                          <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 ring-2 ring-primary/20">
                            <img alt={testimonial.name} className="w-full h-full object-cover" src={testimonial.image} />
                          </div>
                          <div>
                            <h4 className="font-semibold text-foreground">{testimonial.name}</h4>
                            <p className="text-sm text-muted-foreground">{testimonial.role}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="flex justify-center gap-2 mt-6">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentTestimonial(index)}
                    className={`w-2.5 h-2.5 rounded-full transition-all duration-300 cursor-pointer ${
                      currentTestimonial === index ? 'bg-primary w-8' : 'bg-gray-300 hover:bg-gray-400'
                    }`}
                    aria-label={`Ir al testimonio ${index + 1}`}
                  ></button>
                ))}
              </div>
            </div>

            {/* Stats */}
            <div className="mt-12 sm:mt-16 grid grid-cols-2 sm:grid-cols-4 gap-4 sm:gap-6">
              {[
                { value: '2,500+', label: 'Usuarios activos' },
                { value: '4.9/5', label: 'Calificación promedio' },
                { value: '98%', label: 'Satisfacción' },
                { value: '24/7', label: 'Soporte disponible' }
              ].map((stat, index) => (
                <div key={index} className="text-center p-4 sm:p-6 rounded-xl bg-white shadow-card border border-gray-100 hover:shadow-lg hover:-translate-y-1 transition-all duration-300 animate-in fade-in slide-in-from-bottom-6 duration-700">
                  <div className="text-2xl sm:text-3xl font-bold text-gradient mb-1">{stat.value}</div>
                  <p className="text-sm text-muted-foreground">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section id="faq" className="relative py-16 sm:py-24 px-4 sm:px-6 overflow-hidden white-texture-alt">
          <div className="container mx-auto max-w-3xl relative z-10">
            <div className="text-center mb-8 sm:mb-12 animate-in fade-in slide-in-from-bottom-4 duration-700">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 text-primary text-sm font-medium mb-4">
                <i className="ri-question-answer-line text-base"></i>
                Resuelve tus dudas
              </div>
              <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 sm:mb-4 px-2">
                Preguntas <span className="text-gradient">Frecuentes</span>
              </h2>
              <p className="text-base sm:text-lg text-muted-foreground px-2">
                Resolvemos tus dudas sobre BudgetTrack
              </p>
            </div>

            <div className="space-y-3 sm:space-y-4">
              {faqs.map((faq, index) => (
                <div key={index} className="group bg-white rounded-lg sm:rounded-xl border border-gray-100 hover:border-primary/30 px-4 sm:px-6 shadow-sm hover:shadow-lg transition-all duration-300 animate-in fade-in slide-in-from-bottom-6 duration-700">
                  <button
                    onClick={() => setOpenFaqIndex(openFaqIndex === index ? null : index)}
                    className="flex flex-1 items-center justify-between gap-3 w-full text-left text-sm sm:text-base font-semibold py-4 sm:py-5 cursor-pointer group-hover:text-primary transition-colors"
                  >
                    <span className="flex items-center gap-2 sm:gap-3">
                      <span className="w-6 h-6 sm:w-7 sm:h-7 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary/20 transition-colors">
                        <i className="ri-question-line text-primary text-sm sm:text-base"></i>
                      </span>
                      <span>{faq.question}</span>
                    </span>
                    <div className="w-8 h-8 sm:w-9 sm:h-9 rounded-full bg-muted group-hover:bg-primary/10 flex items-center justify-center flex-shrink-0 transition-all duration-300">
                      <i className={`ri-arrow-down-s-line text-lg sm:text-xl transition-transform duration-300 ${openFaqIndex === index ? 'rotate-180' : ''}`}></i>
                    </div>
                  </button>
                  {openFaqIndex === index && (
                    <div className="pb-4 sm:pb-5 pl-8 sm:pl-10 pr-2 text-sm sm:text-base text-muted-foreground leading-relaxed animate-in fade-in slide-in-from-top-2 duration-300">
                      {faq.answer}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="relative py-8 sm:py-12 px-4 sm:px-6 border-t border-gray-100 overflow-hidden bg-gray-50/50">
        <div className="container mx-auto max-w-6xl relative">
          <div className="flex flex-col items-center gap-6 sm:gap-8 md:flex-row md:justify-between">
            <div className="flex items-center gap-2 group cursor-pointer">
              <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-lg gradient-hero flex items-center justify-center group-hover:scale-110 group-hover:rotate-6 transition-all duration-300 shadow-md">
                <span className="text-primary-foreground font-bold text-base sm:text-lg">B</span>
              </div>
              <span className="font-bold text-lg sm:text-xl group-hover:text-primary transition-colors">BudgetTrack</span>
            </div>

            <nav className="flex flex-wrap items-center justify-center gap-4">
              <a href="#beneficios" className="text-muted-foreground hover:text-primary transition-all duration-200 py-1 hover:scale-110 inline-flex items-center gap-1.5 group">
                <i className="ri-gift-line text-base group-hover:rotate-12 transition-transform"></i>
                <span>Beneficios</span>
              </a>
              <a href="#funcionalidades" className="text-muted-foreground hover:text-primary transition-all duration-200 py-1 hover:scale-110 inline-flex items-center gap-1.5 group">
                <i className="ri-function-line text-base group-hover:rotate-12 transition-transform"></i>
                <span>Funcionalidades</span>
              </a>
              <a href="#precio" className="text-muted-foreground hover:text-primary transition-all duration-200 py-1 hover:scale-110 inline-flex items-center gap-1.5 group">
                <i className="ri-price-tag-3-line text-base group-hover:rotate-12 transition-transform"></i>
                <span>Precio</span>
              </a>
              <a href="#faq" className="text-muted-foreground hover:text-primary transition-all duration-200 py-1 hover:scale-110 inline-flex items-center gap-1.5 group">
                <i className="ri-question-line text-base group-hover:rotate-12 transition-transform"></i>
                <span>FAQ</span>
              </a>
            </nav>
          </div>

          <div className="mt-6 sm:mt-8 pt-6 sm:pt-8 border-t border-gray-100">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <p className="text-xs sm:text-sm text-muted-foreground flex items-center gap-1.5">
                Hecho con <i className="ri-heart-fill text-red-500 animate-pulse"></i>
              </p>
              <p className="text-xs sm:text-sm text-muted-foreground text-center">
                © 2026 BudgetTrack. Todos los derechos reservados. • <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors font-medium">Website Builder</a>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
